export namespace AnalyticsTypes {
    export interface AuthorizationResult {
        code?: string
        error?: string
        state?: string
    }

    export enum Error {
        NO_REFRESH_TOKEN = 'No google analytics refresh token found',
        INVALID_TOKEN = 'Invalid google analytics token',
        COULD_NOT_READ_RECENTLY_INSERTED_TOKEN = 'Could not read recently inserted google analytics token',
        REVOKING_TOKEN = 'Failed to get google analytics account data after storing token, revoking token',
        NO_LINKED_PROFILE_FOUND = 'No linked google analytics profile was found',
        ACCESS_DENIED = 'User cancelled authorization',
        NO_AUTHORIZATION_CODE = 'We received no authorization code and google did not provide any error',
        NO_ACCESS_TOKEN = 'Something unexpected happened and we received no access token after authorization',

        // User facing messages
        EMAIL_WITHOUT_ANALYTICS = 'The email address you selected has no associated Google Analytics account. If it does, please contact support.',
        ACCESS_TOKEN_SCOPE_INSUFFICIENT = 'Authorization failed due to insufficient permissions.',
        UNKNOWN_ERROR = 'An unknown error occurred while linking your Google Analytics account. Please contact support.',
    }

    export interface UsersRefreshTokenAndEmail {
        refresh_token: string
        email: string
        google_analytics_refresh_token_id: string
    }

    export interface SavedAccountIdsLegacy {
        profile_id: number
        property_id: string
        account_id: number
    }

    export type SavedAccountIds = {
        profileId: number
        propertyId: string
        accountId: number
    }

    export interface ActiveGAConnections {
        connected_domains: number
    }

    export enum MatadataEntityType {
        Account,
        Property,
        Profile,
    }

    export interface MatadataEntityBase {
        id: string
        name: string
    }

    export interface FormattedAccountData extends MatadataEntityBase {
        properties: FormattedAccountProperty[]
    }

    export interface FormattedAccountProperty extends MatadataEntityBase {
        profiles: MatadataEntityBase[]
    }

    export interface FormattedAccount {
        accounts: FormattedAccountData[]
    }

    export interface Credentials {
        accessToken: string
        connectionId: string
        ga4Email: string
    }
}
